export default __webpack_public_path__ + "static/media/after.6340bd65.png";